export const endpoints = {
    faq: {
        questions: '/items/faq_page?fields=*,list.item.*',
    },
    aboutUs: '/items/about_us_page?fields=*,about_us.*',
    home: '/items/home?fields=products.item.cover,products.item.title,products.item.short_description,*,about_us.*,our_cards.item.*',
    products: '/items/products_page?fields=content_images.directus_files_id,*,products.item.*,products.item.statistics.item.*',
    subscribes: '/items/subscribes_page?fields=*,subscribes_list.item.*',
    resources: '/items/resources_page?fields=*,resources.item:resources.*&deep[resources][_sort]=-item:resources.order',
    header: '/items/header',
    footer: '/items/footer',
};

